import { t } from '@/utils/i18n';
import type { FTWsMessage } from '@/types/wsMessageTypes';
import { FtWsMessageTypes } from '@/types/wsMessageTypes';

export function showNotification(msg: FTWsMessage, botname: string) {
  const settingsStore = useSettingsStore();
  if (settingsStore.notifications && settingsStore.notifications[msg.type]) {
    switch (msg.type) {
      case FtWsMessageTypes.entryFill:
        console.log('entryFill', msg);
        showAlert(
          t('Entry fill: {p0} {p1} at {p2}', {
            p0: msg.pair,
            p1: msg.direction,
            p2: msg.open_rate,
          }),
          'success',
          botname,
        );
        break;
      case FtWsMessageTypes.exitFill:
        console.log('exitFill', msg);
        showAlert(
          t('Exit fill: {p0} {p1} {p2}', { p0: msg.pair, p1: msg.direction, p2: msg.open_rate }),
          'success',
          botname,
        );
        break;
      case FtWsMessageTypes.exitCancel:
        console.log('exitCancel', msg);
        showAlert(
          t('Exit order cancelled for {p0} due to {p1}', { p0: msg.pair, p1: msg.reason }),
          'warning',
          botname,
        );
        break;
      case FtWsMessageTypes.entryCancel:
        console.log('entryCancel', msg);
        showAlert(
          t('Entry order cancelled for {p0} due to {p1}', { p0: msg.pair, p1: msg.reason }),
          'warning',
          botname,
        );
        break;
    }
  } else {
    console.log(`${botname}: Message ${msg.type} not shown.`);
  }
}
